import { breakpoints } from '@constants'
import cn from 'classnames'
import { useGetPendingCallRequestQuery } from 'mmfintech-backend-api'
import { tr, useMatchMedia } from 'mmfintech-commons'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import CallRequestModal from '../CallRequestModal/CallRequestModal'

import styles from './CallRequestFab.module.scss'

function CallRequestFab() {
  const [showModal, setShowModal] = useState(false)
  const [atPageBottom, setAtPageBottom] = useState(false)
  const { data: pending } = useGetPendingCallRequestQuery()
  const { pathname } = useLocation()
  const isPhone = useMatchMedia({ breakpoint: breakpoints.md, prefix: 'max' })

  const hasPending = Boolean(pending?.queueId)
  const isOnSupportPage = pathname.startsWith('/support')

  // On phones the button moves beside the support button once the page is scrolled to the end.
  useEffect(() => {
    if (!isPhone) {
      setAtPageBottom(false)
      return
    }

    const syncPageBottom = () =>
      setAtPageBottom(window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 8)
    syncPageBottom()

    window.addEventListener('scroll', syncPageBottom, { passive: true })
    window.addEventListener('resize', syncPageBottom)
    // The page can grow or shrink (data loading, tab switch) without any scroll event.
    const resizeObserver = new ResizeObserver(syncPageBottom)
    resizeObserver.observe(document.body)

    return () => {
      window.removeEventListener('scroll', syncPageBottom)
      window.removeEventListener('resize', syncPageBottom)
      resizeObserver.disconnect()
    }
  }, [isPhone])

  return (
    <>
      {/* Clashes with the ticket list pagination / compose bar on /support pages
          at mobile widths — hide the trigger button there entirely rather than
          just repositioning it, same pattern SupportFab.tsx uses for its own
          button. The modal itself stays mounted regardless of route: it's
          reachable from any page, and unmounting it here would silently
          discard an in-progress request if the user navigates to /support
          while it's still open. */}
      {!isOnSupportPage && (
        <button
          type='button'
          className={cn(styles['call-request-fab-btn'], {
            [styles['call-request-fab-btn-beside']]: atPageBottom
          })}
          onClick={() => setShowModal(true)}
          title={
            hasPending
              ? tr('FRONTEND.CALL_REQUEST.FAB.TITLE_PENDING', 'Request already pending')
              : tr('FRONTEND.CALL_REQUEST.FAB.TITLE', 'Request a call')
          }
        >
          <svg
            width='22'
            height='22'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2.2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M3 5a2 2 0 0 1 2-2h3.28a1 1 0 0 1 .95.68l1.5 4.49a1 1 0 0 1-.5 1.21l-2.26 1.13a11 11 0 0 0 5 5l1.13-2.26a1 1 0 0 1 1.21-.5l4.49 1.5a1 1 0 0 1 .68.95V19a2 2 0 0 1-2 2h-1C9.72 21 3 14.28 3 6V5Z' />
          </svg>
        </button>
      )}

      <CallRequestModal
        visible={showModal}
        mode={hasPending ? 'pending' : 'form'}
        onClose={() => setShowModal(false)}
      />
    </>
  )
}

export default CallRequestFab
